import { render, staticRenderFns } from "./main-section-shelter-areas-all.vue?vue&type=template&id=9311315a&scoped=true"
import script from "./main-section-shelter-areas-all.vue?vue&type=script&lang=js"
export * from "./main-section-shelter-areas-all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9311315a",
  null
  
)

export default component.exports